import { BetStatus } from '@/models/bet/status';
import { GameLeaderboardTableRowProps } from '../props';
import useTranslation from 'next-translate/useTranslation';
import { GameID, GameIDType } from '@/enums/gameId';
import { getRouletteMultiplier } from './helper';
import { RouletteColor } from '@/models/roulette/color';
import { GameRoundStatusId } from '@/models/round/status/id';
import { BetStatusId } from '@/models/bet/status/id';

export default function Multiplier({
  bet,
  shouldShowResult,
}: GameLeaderboardTableRowProps) {
  const { t } = useTranslation('smash-racing');

  if (
    bet?.status?.id?.toString() !== BetStatusId.Open?.toString() &&
    shouldShowResult
  ) {
    if (bet?.profit?.isPositive()) {
      switch (bet?.game?.id?.toString()) {
        case GameID.Crash.toString():
        case GameID.CrashTrenball.toString():
        case GameID.Slide.toString():
          return `${bet?.crashpointBet?.crashpoint?.toNumberString()}x`;
        case GameID.Double.toString():
        case GameID.Frost.toString():
          return `${Number(getRouletteMultiplier(bet?.rouletteBet?.color as RouletteColor))?.toFixed(2)}x`;
      }
    }

    return <>0.00x</>;
  }

  return <>{t('betting_label')}</>;
}
